import { stringifyUrl } from 'query-string';
import { getTLSOnlineWrapperApiUrl } from '../selectors/getBaseUrlSelectors';

export default {
  fetch: (
    {
      locale, checkIn, checkOut, hotelId, hotelPrograms,
    },
    action,
    state
  ) => ({
    url: stringifyUrl({
      url: `${getTLSOnlineWrapperApiUrl(state)}/v1/${locale}/hotelOffers`,
      query: {
        checkIn,
        checkOut,
        ecom_hotel_ids: hotelId,
        hotelPrograms: hotelPrograms || 4,
        availOnly: false,
        sortType: 'PREMIUM',
      },
      opts: {
        credentials: 'omit',
      },
    }),
  }),
};
